export const SHOW_INPUT_TILE_POPOVER = 'SHOW_INPUT_TILE_POPOVER';
export const HIDE_INPUT_TILE_POPOVER = 'HIDE_INPUT_TILE_POPOVER';
export const UPDATE_INPUT_FIELD = 'UPDATE_INPUT_FIELD';

export const showInputTilePopover = (selectedInputile: string) => ({
  type: SHOW_INPUT_TILE_POPOVER,
  payload: selectedInputile,
});

export const hideInputTilePopover = () => ({
  type: HIDE_INPUT_TILE_POPOVER,
});

export const updateInputField = (field: any) => ({
  type: UPDATE_INPUT_FIELD,
  payload: field,
});
